const BASE_ACTION = "SYSTEMS/";
export const FETCH_SYSTEMS_START = `${BASE_ACTION}FETCH_SYSTEMS_START`;
export const FETCH_SYSTEMS_SUCCESS = `${BASE_ACTION}FETCH_SYSTEMS_SUCCESS`;
export const UPDATE_SYSTEMS = `${BASE_ACTION}UPDATE_SYSTEMS`;
export const UPDATE_SYSTEM_CONNECTION_STATUS = `${BASE_ACTION}UPDATE_SYSTEM_CONNECTION_STATUS`;
export const FETCH_SYSTEMS_FAIL = `${BASE_ACTION}FETCH_SYSTEMS_FAIL`;
export const RESET_SYSTEMS = `${BASE_ACTION}RESET_SYSTEMS`;
